export const contactFieldClass =
  'font-matter text-text-primary placeholder:text-text-muted border-border-soft bg-surface-input focus:border-brand-primary focus:ring-brand-primary/20 w-full rounded-[12px] border px-4 py-3 text-[16px] outline-none transition-all focus:ring-2';
